<div #container (click)="selectTagInput($event)" class="container">
	<div class="bb-multiselect">
		<div class="tag-pill" [(ngModel)]="tags" *ngFor="let tag of tags; let index = index" ngDefaultControl>
			<span #selectedEntities [ngClass]="{'selected': selected, 'hide': hide}">{{ tag }} <i class="fa fa-times"
				 (click)="removeSelectedEntity(tag)"></i></span>
		</div>
		<div class="input-wrapper">
			<input type="text" #tagInputEntity (keyup)="searchTerm.next($event)" [ngClass]="{'selected': selected, 'hide': hide}" (click)="selectTagInput($event)" value="{{ tagInput }}"/>
		 </div>
	</div>
</div>
<!-- <div class="bb-multiselect">
	<ul *ngIf="results && showMediaclips">
		<li *ngFor="let result of results">
			<i *ngIf="result.status == 'published'" class="fa fa-circle green"></i>
			<i *ngIf="result.status == 'draft'" class="fa fa-circle red"></i>
			<a href="javascript:void(0)" (click)="selectMediaclip($event,result)">{{ result.name }}</a>
		</li>
	</ul>
</div> -->